import { IVesselOnePart } from "./IVesselOneParts";

export type IVesselOneParametrization = IVesselOneSizeParametrization &
  IVesselOneParametrizationWithoutSize &
  IVesselOneDecalsParametrization;

export type IVesselOneParametrizationWithoutSize =
  IVesselOneVisibilityParametrization &
    IVesselOneLabelParametrization &
    IVesselOneColorsParametrization &
    IVesselOneTailParametrization;

export type IVesselOneParametrizationFormElements = {
  labels: IVesselOneLabelParametrization;
  colors: IVesselOneColorsParametrization;
  tailOptions: IVesselOneTailParametrization;
};

export interface IVesselOneSizeParametrization {
  maxBay: number;
  maxCell: number;
  minCell: number;
  aboveDeck: number;
  belowDeck: number;
  parts: IVesselOnePart[];
}

export interface IVesselOneVisibilityParametrization {
  visible: boolean;
  shellVisible: boolean;
  bayNumbersVisible: boolean;
  deckVisible: boolean;
  belowSeparatorsVisible: boolean;
}

export interface IVesselOneLabelParametrization {
  labelVesselName: string;
  labelIMOCode: string;
  labelCountry?: string;
  labelLateral?: string;
}

export interface IVesselOneColorsParametrization {
  mainColor: string;
  belowSeparatorColor: string;
  bottomColor: string;
  bridgeColor: string;
  cranesColor: string;
  labelsBaysColor: string;
  labelsNoseColor: string;
  labelsSideColor: string;
  labelsTailColor: string;
  separatorColor: string;
  smokeBottomColor: string;
  smokeTopColor: string;
}

export interface IVesselOneDecalsParametrization {
  damagesShapes: [];
  decals: [];
}

export interface IVesselOneTailParametrization {
  propellers: number;
  rudders: number;
}

export const DEFAULT_VESSEL_ONE_PRMS: IVesselOneParametrizationWithoutSize = {
  visible: true,
  shellVisible: true,
  bayNumbersVisible: true,
  deckVisible: true,
  belowSeparatorsVisible: true,
  labelVesselName: "Vessel Name",
  labelIMOCode: "IMO Code",
  belowSeparatorColor: "#b8b4a9",
  bottomColor: "#b5736e",
  bridgeColor: "#cccccc",
  cranesColor: "#464b59",
  labelsBaysColor: "#cccccc",
  labelsNoseColor: "#dddddd",
  labelsSideColor: "#eeeeee",
  labelsTailColor: "#dddddd",
  mainColor: "#7384a2",
  separatorColor: "#700000",
  smokeBottomColor: "#cccccc",
  smokeTopColor: "#333333",
  propellers: 1,
  rudders: 2,
};
